var app = angular.module('leonardo');

var PropertyName = function (PropertyService) {
  return function (pk) {
    var label = 'Invalid property';
    angular.forEach(PropertyService.getCollection(), function(property) {
      if (property.id == pk) {
        label = property.name;
      }
    });
    return label;
  };
};

app.filter('propertyName', ['PropertyService', PropertyName]);
